<template>
  <router-view/>
</template>

<style>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons+Round");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
